import { View } from './view'

export const FooterV2 = View
